/* Core-on-demand: loaded only when the logo marquee section renders. */
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { LogoMarquee } from '@/scripts/optional/logo-marquee'

q.safeDefineElement(LogoMarquee)
